import { axiosWithAuth } from "helpers";
import { TidTabs } from "types";

export const tidEquipmentQaQueueService = {
	getList,
	getAssignedTo,
	assignToUser,
	claimAssigned,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getAssignedTo(pattern, page, showInactive = false) {
	const body = {
		pattern,
		page,
		pageSize: 20,
		showInactive,
	};

	const options = {
		method: "POST",
		data: body,
		url: `${API_URL}/api/applications/equipment_queue/users`,
	};

	return axiosWithAuth(options);
}

function getList({ page, sortBy, filters, tabName }) {
	let tab;
	if (tabName === TidTabs.QAComplete.name) {
		tab = "completed";
	} else if (tabName === TidTabs.QAUnassigned.name) {
		tab = "unassigned";
	} else {
		tab = "in_progress";
	}

	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			mid: filters?.mid,
			merchant_name: filters?.merchantName,
			number: filters?.number,
			agent_office: filters?.agentOffice,
			agent_name: filters?.agentName,
			terminal_number: filters?.terminalNumber,
			manufacturer_id: filters?.manufacturerId,
			model_id: filters?.modelId,
			equipment_qa_assignee_id: filters?.assignedTo?.id,
			sort_type: sortBy?.id ? sortBy?.id : undefined,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
			pend_status: filters?.pendStatus?.name,
		},
		url: `${API_URL}/api/applications/equipment_queue/qa/${tab}`,
	};

	return axiosWithAuth(options);
}

function claimAssigned(applicationId, claimName) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/equipment_queue/qa/${applicationId}/${claimName}`,
	};

	return axiosWithAuth(options);
}

function assignToUser(applicationId, assignedId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/equipment_queue/qa/${applicationId}/assign_to/${assignedId}`,
	};

	return axiosWithAuth(options);
}
